import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenesysCloudConfigService } from 'common/genesys-cloud-config';
import { GenesysCloudPlatformApiService } from 'common/store/genesys-cloud/common/services/genesys-cloud-platform-api.service';
import { map, Observable } from 'rxjs';

export interface MediaUploadResponse {
  correlationId: string;
  files: string[];
}

@Injectable({
  providedIn: 'root'
})
export class MessageConversationMediaUploadApiService extends GenesysCloudPlatformApiService {
  constructor(readonly httpClient: HttpClient, protected readonly configService: GenesysCloudConfigService) {
    super(httpClient, configService);
    super.commonHeaders$ = this.configService.apiConfig$.pipe(
      map(apiConfig => ({ Authorization: `Bearer ${apiConfig.accessToken}`}))
    );
  }

  uploadMedia$(url: string, media: FormData): Observable<MediaUploadResponse> {
    return this.post$<MediaUploadResponse>(url, media);
  }

  override createUrl(path: string): string {
    return path;
  }
}
